module.exports = __webpack_public_path__ + "static/img/program_media_img.4679197c.png";